import SuccessView from '../components/views/SuccessView'
import login from '../assets/login.png'
import strings from '../res/strings'

const RecoverPasswordSuccess = () => {
    return (
        <div className='flex flex-row'>
            <div className='flex-1'>
                <img className='min-h-screen object-cover' src={login} alt='Login Alagem Digital'/>
            </div>
            
            <SuccessView 
                message={strings.newPasswordSuccess}
            />
        </div>
  )
}

export default RecoverPasswordSuccess